import React from 'react';
import { getClass } from '../../_lib/helper';
function DescriptionListLabel(_a) {
    var hasDivider = _a.hasDivider, children = _a.children;
    return (React.createElement("dt", { className: getClass('elmo-dl__dt', {}, { 'has-divider': !!hasDivider }) }, children));
}
export default DescriptionListLabel;
